import { Handle, Position } from '@xyflow/react'
import { nodeControlClass } from '../../lib/nodeControlClass.js'
import { fieldNumber } from '../../lib/fieldNumber.js'
import { selectedBorder } from './selectedBorder.js'

export function RandomNode({ data, selected }) {
  const type = data.randomType ?? 'float'
  const min  = data.min ?? 0
  const max  = data.max ?? 1
  const color = '#c080e0'

  return (
    <div style={{
      background: selected ? '#1e1428' : '#160f1e',
      border: `2px solid ${selected ? selectedBorder('#603090') : '#603090'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 200,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      {/* Title + type toggle */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
        <span style={{ fontSize: 13, fontStyle: 'italic', color: '#90c090' }}>ƒ</span>
        <span style={{ color, fontWeight: 'bold', fontSize: 11 }}>
          Random {type === 'int' ? 'Integer' : 'Float'} in Range
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 0, borderRadius: 3, overflow: 'hidden', border: '1px solid #402060' }}>
          {['float', 'int'].map(t => (
            <button
              key={t}
              onMouseDown={e => e.stopPropagation()}
              onClick={() => data.onChange?.('randomType', t)}
              style={{
                background: type === t ? '#402060' : 'transparent',
                border: 'none',
                color: type === t ? color : '#504060',
                padding: '2px 7px',
                fontSize: 9,
                fontFamily: 'var(--m-font)',
                cursor: 'pointer',
              }}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {/* Min row */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, position: 'relative' }}>
        <span style={{ color: '#a060d0', fontSize: 10, minWidth: 30 }}>Min</span>
        <input
          className={nodeControlClass()}
          type="number"
          value={min}
          step={type === 'int' ? 1 : 0.1}
          onChange={e => data.onChange?.('min', parseFloat(e.target.value) || 0)}
          onMouseDown={e => e.stopPropagation()}
          style={numInput}
        />
      </div>

      {/* Max row + Return Value handle */}
      <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
        <span style={{ color: '#a060d0', fontSize: 10, minWidth: 30 }}>Max</span>
        <input
          className={nodeControlClass()}
          type="number"
          value={max}
          step={type === 'int' ? 1 : 0.1}
          onChange={e => data.onChange?.('max', fieldNumber(e.target.value))}
          onMouseDown={e => e.stopPropagation()}
          style={numInput}
        />
        <span style={{ marginLeft: 'auto', color: color, fontSize: 10, paddingRight: 14 }}>
          Return Value
        </span>
        <Handle
          type="source"
          position={Position.Right}
          id="value"
          style={{ background: color, width: 10, height: 10 }}
        />
      </div>
    </div>
  )
}

const numInput = {
  width: 70,
  background: '#0f0a18',
  border: '1px solid #2a1540',
  color: '#ccc',
  padding: '3px 6px',
  borderRadius: 3,
  fontSize: 10,
  fontFamily: 'var(--m-mono)',
  outline: 'none',
}
